<template>
  <fluid-form-item :label="label">
    <v-radio-group v-model="modelValue" row dense :disabled="disabled" @change="valueChange">
      <v-radio v-for="item in $dict.map[group]" :key="item.value" :label="item.name" :value="item.value"></v-radio>
    </v-radio-group>
    <p class="help-block" v-if="tips">{{ tips }}</p>
  </fluid-form-item>
</template>

<script>
  import FluidFormItem from "./FluidFormItem";

  export default {
    name: "MRadio",
    data() {
      return {
        modelValue: this.value
      };
    },
    model: {
      prop: "value",
      event: "change"
    },
    props: {
      group: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        required: true
      },
      disabled: {
        type: Boolean,
        required: false
      },
      tips: {
        type: String,
        required: false
      }
    },
    watch: {
      value: {
        handler(val) {
          this.modelValue = val;
        },
        immediate: true
      }
    },
    components: { FluidFormItem },
    methods: {
      valueChange() {
        this.$emit("change", this.modelValue);
      }
    }
  };
</script>

<style scoped></style>
